import React from 'react';

const Features = () => {
  return (
    <section className="w-full bg-surface-dark border-y border-border-dark" id="features">
      <div className="max-w-[1200px] mx-auto px-4 py-16 md:px-10">
        <div className="flex flex-col gap-4 mb-12">
          <h2 className="text-white text-3xl md:text-4xl font-bold leading-tight tracking-[-0.033em] max-w-[720px]">
            Everything you need,<br /> <span className="text-text-muted">nothing you don't.</span>
          </h2>
          <p className="text-text-muted text-base font-normal max-w-[720px]">Designed specifically for the modern UPI power user in India.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="group flex gap-3 rounded-2xl border border-border-dark bg-[#1a2332] p-6 hover:border-primary/50 transition-colors">
            <div className="flex-shrink-0">
              <div className="size-12 rounded-full bg-primary/10 flex items-center justify-center">
                <svg className="w-6 h-6 text-primary" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
                </svg>
              </div>
            </div>
            <div className="flex flex-col gap-1">
              <h3 className="text-white text-base font-bold">PDF Import</h3>
              <p className="text-text-muted text-sm leading-relaxed">Import transaction PDFs from UPI apps securely. We process them locally without uploading.</p>
            </div>
          </div>
          <div className="group flex gap-3 rounded-2xl border border-border-dark bg-[#1a2332] p-6 hover:border-primary/50 transition-colors">
            <div className="flex-shrink-0">
              <div className="size-12 rounded-full bg-primary/10 flex items-center justify-center">
                <svg className="w-6 h-6 text-primary" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"/>
                </svg>
              </div>
            </div>
            <div className="flex flex-col gap-1">
              <h3 className="text-white text-base font-bold">Unified Transaction View</h3>
              <p className="text-text-muted text-sm leading-relaxed">View all transactions from multiple UPI apps in a single timeline with smart filters.</p>
            </div>
          </div>
          <div className="group flex gap-3 rounded-2xl border border-border-dark bg-[#1a2332] p-6 hover:border-primary/50 transition-colors">
            <div className="flex-shrink-0">
              <div className="size-12 rounded-full bg-primary/10 flex items-center justify-center">
                <svg className="w-6 h-6 text-primary" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z"/>
                </svg>
              </div>
            </div>
            <div className="flex flex-col gap-1">
              <h3 className="text-white text-base font-bold">Spending Analytics</h3>
              <p className="text-text-muted text-sm leading-relaxed">Get visual breakdowns of your spending patterns with interactive charts and graphs.</p>
            </div>
          </div>
          <div className="group flex gap-3 rounded-2xl border border-border-dark bg-[#1a2332] p-6 hover:border-primary/50 transition-colors">
            <div className="flex-shrink-0">
              <div className="size-12 rounded-full bg-primary/10 flex items-center justify-center">
                <svg className="w-6 h-6 text-primary" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2l-5.5 9h11L12 2zm0 3.84L13.93 9h-3.87L12 5.84zM17.5 13c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm0 7c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM3 21.5h8v-8H3v8zm2-6h4v4H5v-4z"/>
                </svg>
              </div>
            </div>
            <div className="flex flex-col gap-1">
              <h3 className="text-white text-base font-bold">Category Insights</h3>
              <p className="text-text-muted text-sm leading-relaxed">Auto-categorize your transactions. Track spending by food, shopping, bills, and more.</p>
            </div>
          </div>
          <div className="group flex gap-3 rounded-2xl border border-border-dark bg-[#1a2332] p-6 hover:border-primary/50 transition-colors">
            <div className="flex-shrink-0">
              <div className="size-12 rounded-full bg-primary/10 flex items-center justify-center">
                <svg className="w-6 h-6 text-primary" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M21.9 8.89l-1.05-4.37c-.22-.9-1-1.52-1.91-1.52H5.05c-.9 0-1.69.63-1.9 1.52L2.1 8.89c-.24 1.02-.02 2.06.62 2.88.08.11.19.19.28.29V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6.94c.09-.09.2-.18.28-.28.64-.82.87-1.87.62-2.89zM18.91 4.99l1.05 4.37c.1.42.01.84-.25 1.17-.14.18-.44.47-.94.47-.61 0-1.14-.49-1.21-1.14L16.98 5l1.93-.01zM13 5h1.96l.54 4.52c.05.39-.07.78-.33 1.07-.22.26-.54.41-.95.41-.67 0-1.22-.59-1.22-1.31V5zM8.49 9.52L9.04 5H11v4.69c0 .72-.55 1.31-1.29 1.31-.34 0-.65-.15-.89-.41-.25-.29-.37-.68-.33-1.07zm-4.45-.16L5.05 5h1.97l-.58 4.86c-.08.65-.6 1.14-1.21 1.14-.49 0-.8-.29-.93-.47-.27-.32-.36-.75-.26-1.17zM5 19v-6.03c.08.01.15.03.23.03.87 0 1.66-.36 2.24-.95.6.6 1.4.95 2.31.95.87 0 1.65-.36 2.23-.93.59.57 1.39.93 2.29.93.84 0 1.64-.35 2.24-.95.58.59 1.37.95 2.24.95.08 0 .15-.02.23-.03V19H5z"/>
                </svg>
              </div>
            </div>
            <div className="flex flex-col gap-1">
              <h3 className="text-white text-base font-bold">Merchant-wise Reports</h3>
              <p className="text-text-muted text-sm leading-relaxed">See detailed reports on your top merchants and payment trends with each vendor.</p>
            </div>
          </div>
          <div className="group flex gap-3 rounded-2xl border border-border-dark bg-[#1a2332] p-6 hover:border-primary/50 transition-colors">
            <div className="flex-shrink-0">
              <div className="size-12 rounded-full bg-primary/10 flex items-center justify-center">
                <svg className="w-6 h-6 text-primary" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/>
                </svg>
              </div>
            </div>
            <div className="flex flex-col gap-1">
              <h3 className="text-white text-base font-bold">Google Drive Backup</h3>
              <p className="text-text-muted text-sm leading-relaxed">Optionally backup your data to your private Google Drive folder with end-to-end encryption.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
